import { Component, OnInit } from '@angular/core';
import { AuthenticationService, GlobalInfoService } from '@app/core';
import { Const } from '@app/shared';

@Component({
  selector: 'iw-utilitarios-management',
  templateUrl: './utilitarios-management.component.html',
  styleUrls: ['./utilitarios-management.component.scss']
})
export class UtilitariosManagementComponent implements OnInit {

  // define la posicion del tab
  tab = 'tab-flow';
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    tab_flow: false,
    tab_calendar: false,
    tab_users_persistent: false,
    tab_replace_users: false
  };
   constructor(
     private gis: GlobalInfoService,
     private as: AuthenticationService,
    ) {}

  ngOnInit() {
     // se setea el titulo de la vista actual
     this.gis.set({ title: 'Gestión de utilitarios' });
     // determina los permisos del usuario en sesion
    this.activateAction.tab_replace_users = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.replaceUsers,
    );
    this.activateAction.tab_flow = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabFlow,
    );
    this.activateAction.tab_calendar = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabCalendar,
    );
    this.activateAction.tab_users_persistent = this.as.confirmPermission(
      Const.types_permissions.administrationUtilities,
      Const.types_action_permissions.tabUsersPersistent,
    );

    this.initializeTabs();

   
  }

  initializeTabs() {
    if (this.activateAction.tab_flow) {
      this.tab = 'tab-flow';
    } else if (this.activateAction.tab_calendar) {
      this.tab = 'tab-calendar';
    } else if (this.activateAction.tab_users_persistent) {
      this.tab = 'tab-userPersistent';
    } else if (this.activateAction.tab_replace_users) {
      this.tab = 'tab-replace-users';
    }
  }

  /**
   * Esta funcion hace el cambio de tab, genera la tabla
   * y consulta los registros de las tablas dependiendo de el tab
   *
   * @param {string} [accion='tab-flow']
   * @memberof UtilitariosManagementComponent
   */
   changeTab(accion: string = 'tab-flow') {
    this.tab = accion;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/utilitarios-management/utilitarios-management.component.ts